import { useState, useEffect } from 'react'
import { Modal, Button, Form } from 'react-bootstrap'
import { Request } from '@group-devs/yfp7-global-modules'
import Authenticator from '@group-devs/yfp7-authenticator'
import Link from 'next/link'
import Recaptcha from '../general/Recaptcha';
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import Spinner from 'react-bootstrap/Spinner'

const request = new Request(process.env.apiDomain)
const axiosapi = require('../../pages/api/AxiosApi.js');

function CreateAccount(props) {

    let site = props.site.site
    let metadata = props.metadata

    const { data: ownerAccount } = request.account.swrAccountProfile(site ? site.accountId : '')
    const { data: hub } = request.website.swrSite(site ? site.accountId : '', "HUB")
    const { data: countryList } = request.core.swrCountries({is_active : 1})

    const [validationUrl, setUrl] = useState('')
    const [loginUrl, setLoginUrl] = useState('')

    const [errorRecaptcha, setErrorRecaptcha] = useState("google-captcha")
    const [show, setShow] = useState(false);
    const [verified, setVerified] = useState(false)
    const [password_verified, setPasswordVerified] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')
    const [isLogin, setIsLogin] = useState(false)
    const [loader, setLoader] = useState(false)

    const [data, setData] = useState({
      firstname: '',  
      lastname: '',
      email: '',
      phone_number: '',
      password: '',
      confirm_password: '',
      country_code: ''
    })

    const [errorMsg, setErrorMsg] = useState({
      firstname: '',  
      lastname: '',
      email: '',
      emailExist: '',
      phone_number: '',
      password: '',
      confirm_password: '',
      country_code: ''
    })
    
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    useEffect(() => {
      let url, host, loginurl;
      host = new URL(window.location.href);
      url  = new URL(`${host.protocol}//${host.host}/api/post`);
      url.searchParams.append('action', 'optin')
      setUrl(url)

      loginurl  = new URL(`${host.protocol}//${host.host}/api/authenticate`);
      loginurl.searchParams.append('continue', '/home')
      setLoginUrl(loginurl)

      if (typeof props.site !== 'undefined') {
        const IsLogin = props.site.auth.isAuthenticated;
        setIsLogin(IsLogin)
      }

    }, [])


    const checkVerification = verified => {
        setVerified(verified);
    }

    const verifyPassword = (password, confirm_password) => {
      if (password != "" && confirm_password != ""){
        if (password === confirm_password){
          setPasswordVerified(true)
        }
      }
    }

    const checkErrMsgs = () => {
      var err = 0;
      const errList = Object.entries(errorMsg).map(([key,value])=>{
          if (value != null || value != "")
              err++;
      },[err])

      if (err)
          return false;
      else
          return true;
    }

    const handleChange = (evt) => {
      const value = evt.target.value
      setData({
        ...data,
        [evt.target.name]: value
      })
    }

    const restrictNumbers = (evt) => {
      const value = evt.target.value
      const result = value.replace(/[^a-z]/gi, '');

      setData({
        ...data,
        [evt.target.name]: result
      })
    }

    const isValidEmail = async (evt) => {
      const validEmail = /\S+@\S+\.\S+/.test(evt.target.value);
      const email = evt.target.value;
      if (!validEmail) {
        setErrorMsg({
          ...errorMsg,
          [evt.target.name]: 'Email is invalid',
          ['emailExist']: ''
        });
      }
      else{
        var emailExist = await onCheckEmail(email);
        if(emailExist)
        {
          setErrorMsg({
            ...errorMsg,
            [evt.target.name]: '*Oh it seems your email is already in our system.',
            ['emailExist']: 1
          });
        }
        else
        {
          setErrorMsg({
            ...errorMsg,
            [evt.target.name]: ''
          });
        }
        
      }
    }

    const setCountry = (value, country, e, formattedValue) => {
      setData({
        ...data,
        ['country_code']: country.countryCode,
        ['phone_number']: value.slice(country.dialCode.length)
      })
    }

    function checkPasswordConfirmation(event) {
      const confirm_password = event.target.value
      var errMsg = ""

      if(data.password != "" && data.password !== confirm_password) {
        if(data.password !== confirm_password) {
          errMsg = "Password doesn't match"
        }
      }

      if(data.password == "") {
        errMsg = "Password is empty"
      }
      
      setErrorMsg({
        ...errorMsg,
        [event.target.name]: errMsg
      });
    }

    function checkPassword(event) {
      const password = event.target.value
      var errMsg = ""

      if (data.confirm_password != "") {
        if(password !== data.confirm_password) {
            errMsg = "Password doesn't match"
        }

        setErrorMsg({
          ...errorMsg,
          ['confirm_password']: errMsg
        });
      }
    }

    function fetchResponseErrors(responseErr)
    {
        let errData = {};

        const errList = Object.entries(responseErr).map(([key,value])=>{
            const errField = key.toString();
            const errValue = value.toString();
            var errors = Object.assign({}, errData);
            errors[errField] = errValue;
            errData = errors;
        })
        
        setErrorMsg(errData);
    }

    async function onCheckEmail(email,req="",res="")
    {
      let _response, axiosApi = new axiosapi(req, res, process.env, process.env.apiDomain)

      _response = await axiosApi.postCheckEmail(email)
      
      return _response.data.contact;
    }

    async function onSubmit (e) {
      e.preventDefault()

      setLoader(true)

      // Clear error message on submit
      setErrorMessage('')

      const checkErrMsg = checkErrMsgs();
      if (verified) {
        setErrorRecaptcha("google-captcha");
        
        const formData = new FormData(e.target),
            formDataObj = Object.fromEntries(formData.entries())

        if (verifyPassword(formDataObj.password, formDataObj.confirm_password)) {
          return false
        }
      
        let newData, post, meta_data, metaDataDetails, loginDetails = {}

        metaDataDetails = {
          code: site.site.code,
          name: site.site.name
        }

        meta_data = Buffer.from(JSON.stringify(metaDataDetails)).toString('base64')

        newData = {
          websiteId: site.websiteId,
          meta_data: meta_data,
          userId: ownerAccount ? ownerAccount.userId : ''
        }

        post = {...formDataObj, ...newData}
        console.log(post)
        
        loginDetails = {
          email: post.email,
          password: post.password,
          websiteId: site.websiteId,
          domain: hub.url,
          csrf: metadata.csrf,
        }

        function handleSuccess(data) {
          if (data.token === null)
              setErrorMessage(data.message)
          return data
        }

        if (checkErrMsgs) {
          const _response = await fetch(validationUrl, {
            method: 'POST',
            headers: Authenticator.getJSONHeaders(),
            body: JSON.stringify(post)
          })
          .then((response) => { return response.json() })
          .catch(function(error) { console.log(error) })

          // Parse response to object
          let newResponse = JSON.parse(_response);

          if (typeof newResponse === 'object'){
            if (newResponse.code === 200) {
              const newResponse = await fetch(loginUrl, {
                method: 'POST',
                headers: Authenticator.getJSONHeaders(),
                body: JSON.stringify(loginDetails)
              })
              .then((response) => { return response.json() })
              .then((data) => handleSuccess(data)).catch((error) => {
                  console.log(error)
              })
              
              // Parse response to object
              const autoLoginResponse = JSON.parse(newResponse);

              if (typeof autoLoginResponse === 'object'){
                  if (autoLoginResponse.code === 200) {
                      if (typeof window !== 'undefined') {
                          window.location.href = '/home'
                      }
                  }
              }
            }else{
              if (typeof newResponse.error === 'string') {
                setLoader(false)
                var errors = newResponse.error
                fetchResponseErrors(JSON.parse(errors));
              }
            }
          }
        }

      }else{
        setLoader(false)
        setErrorRecaptcha("google-captcha error_chk");
      }
    }
    return (
      <>
        {isLogin 
          ?
          <Link href="/home" passHref><a className={`${props.bgcolor} mb-4 rounded-pill ${props.txtcolor} d-inline-block btn-p border-green font-weight-bold`}>ENTER</a></Link>
          :
        <Button variant="" onClick={handleShow} className={`${props.bgcolor} mb-4 rounded-pill ${props.txtcolor} d-inline-block btn-p border-green font-weight-bold`}>
          JOIN FREE TODAY
        </Button>
        }
  
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton className="border-0 pb-0">
            <div className="text-center mx-auto">
                <h3 className="font-weight-light my-3">Create a FREE Account!</h3>
                  <img className="img-fluid mb-3" src="../images/login/img-wellness-center-logo02.png" alt="YWP Logo" width="320"/>
                <p className="mb-0 lh-1-5">Get instant access to our digital library of e-books,<br className="d-md-block d-none"/>archived events, wellness resources and more.</p>
            </div>
          </Modal.Header>
            <Modal.Body>
              <div className="text-danger mb-3 h7">{errorMessage}</div>
              <Form className="mx-auto h7" onSubmit={onSubmit}>
                <input type="hidden" name="siteFrom" value="wellness"/>
                <Form.Group controlId="firstname">
                  <Form.Label>First Name</Form.Label>
                  <Form.Control
                    type="text"
                    className="border-green"
                    name="firstname"
                    value={data.firstname}
                    onChange={restrictNumbers}
                    required
                  />
                  <Form.Text className="text-danger">{errorMsg.firstname}</Form.Text>
                </Form.Group>
                <Form.Group controlId="lastname">
                  <Form.Label>Last Name</Form.Label>
                  <Form.Control
                    type="text"
                    className="border-green"
                    name="lastname"
                    value={data.lastname}
                    onChange={restrictNumbers}
                    required
                  />
                  <Form.Text className="text-danger">{errorMsg.lastname}</Form.Text>
                </Form.Group>
                <Form.Group controlId="email">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    className="border-green"
                    name="email"
                    value={data.email}
                    onChange={handleChange}
                    onBlur={isValidEmail}
                    required
                  />
                  {errorMsg.email ? <><Form.Text className="text-danger">{errorMsg.email}</Form.Text></>:""}
                  {errorMsg.email && errorMsg.emailExist ? <><Form.Text className="text-danger">Please <Link href="/login" passHref><a>click here to login</a></Link> to your account.</Form.Text></>:""}
                </Form.Group>
                <Form.Group controlId="phoneNumber">
                <Form.Label>Phone Number</Form.Label>
                  <PhoneInput
                    country={'us'}
                    onlyCountries={countryList ? countryList.map(item => item.alpha2.toLowerCase()) : ['us']}
                    preferredCountries={['us']}
                    defaultMask={'...-...-....'}
                    alwaysDefaultMask={'true'}
                    inputClass="border-green"
                    inputStyle={{width:'100%'}}
                    inputName="phoneNumber"
                    inputProps={{
                      name: 'phoneNumber',
                      required: true,
                      autoFocus: true
                    }}
                    onChange={setCountry}
                  />
                </Form.Group>

                <Form.Group controlId="phone_number">
                  <Form.Control type="hidden" name="phone_number" value={data.phone_number} /> 
                  <Form.Text className="text-danger">{errorMsg.phone_number}</Form.Text>
                </Form.Group>

                <Form.Group controlId="country_code">
                  <Form.Control type="hidden" name="country_code" value={data.country_code} /> 
                </Form.Group>
                <Form.Group controlId="password">
                  <Form.Label>Password</Form.Label>
                  <Form.Control
                    type="password"
                    className="border-green"
                    name="password"
                    value={data.password}
                    onChange={handleChange}
                    onBlur={checkPassword}
                    required
                  />
                  <Form.Text className="text-danger">{errorMsg.password}</Form.Text>
                </Form.Group>
                <Form.Group controlId="confirm_password">
                  <Form.Label>Confirm Password</Form.Label>
                  <Form.Control
                    type="password" 
                    className="border-green"
                    name="confirm_password"
                    value={data.confirm_password}
                    onChange={handleChange}
                    onBlur={checkPasswordConfirmation}
                    required
                  />
                  <Form.Text className="text-danger">{errorMsg.confirm_password}</Form.Text>
                </Form.Group>

                <div className={errorRecaptcha}>
                    <Recaptcha checkVerification={checkVerification} />
                </div>

                <Button variant="" type="submit" className="mx-auto d-block text-uppercase bg-green my-2 border-green rounded-pill text-white d-inline-block btn-p">
                {
                  (loader) ?
                      <Spinner animation="border" role="status">
                          <span className="sr-only"></span>
                      </Spinner>
                  :
                    'Join Free Today'
                }
                </Button>
          
              </Form>
              <p className="createaccount__footer text-center lh-1-5">Your information is safe with us.<br />
                  We'll never sell or rent your details to anyone, for any reason ever!
              </p>
            </Modal.Body>
        </Modal>
        <style jsx global>{`
                .modal-dialog{
                    max-width:768px;
                }
                form{
                    max-width:400px;
                }
                .modal-header .close{
                    right: 1rem;
                    position: absolute;
                    font-size: 1.8rem;
                    top: .5rem;
                }
                .createaccount__footer{
                    font-size:.84rem;
                }
                .grecaptcha > div > div > div > div{
                    margin: 1rem auto;
                }
                .form-control{
                    height:34px;
                }
                .google-captcha > div > div > div > div{
                  margin: 1rem auto;
                }
                .error_chk {
                  border: 1px solid red !important;
                }
            `}
        </style>
      </>
    );
  }
  
export default CreateAccount